import { jsxs as i, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as t } from "./index.es2359.js";
function d({ size: l = t }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M24.389 35.3317V39.9532C24.389 40.751 25.0357 41.3977 25.8334 41.3977H30.1668C30.9645 41.3977 31.6112 40.751 31.6112 39.9532V35.3317C29.3496 36.4862 26.6506 36.4862 24.389 35.3317Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M33.6176 33.8706C30.5149 36.9733 25.4854 36.9733 22.3827 33.8706C19.2801 30.7679 19.2801 25.7384 22.3827 22.6357C25.4854 19.533 30.5149 19.533 33.6176 22.6357C36.7203 25.7384 36.7203 30.7679 33.6176 33.8706Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M28.5001 15.9757V18.1424H27.5001V15.9757H28.5001Z", fill: "#5E63E5" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.0291 22.2824C25.327 18.9845 30.6731 18.9845 33.9711 22.2824C37.269 25.5803 37.269 30.9265 33.9711 34.2244C33.4046 34.7909 32.7777 35.26 32.1112 35.6319V39.9532C32.1112 41.0271 31.2406 41.8977 30.1668 41.8977H25.8334C24.7595 41.8977 23.889 41.0271 23.889 39.9532V35.6319C23.2224 35.26 22.5955 34.7909 22.0291 34.2244C18.7311 30.9265 18.7311 25.5803 22.0291 22.2824ZM33.264 22.9895C30.3565 20.0821 25.6436 20.0821 22.7362 22.9895C19.8288 25.8969 19.8288 30.6099 22.7362 33.5173C25.6436 36.4247 30.3565 36.4247 33.264 33.5173C36.1714 30.6099 36.1714 25.8969 33.264 22.9895ZM24.889 36.1061V38.5868H28.7223C28.9985 38.5868 29.2223 38.8106 29.2223 39.0868C29.2223 39.3629 28.9985 39.5868 28.7223 39.5868H24.889V39.9532C24.889 40.4748 25.3118 40.8977 25.8334 40.8977H30.1668C30.6884 40.8977 31.1112 40.4748 31.1112 39.9532V36.1061C29.117 36.8951 26.8832 36.8951 24.889 36.1061Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M18.2423 19.8166C18.4376 19.6213 18.4376 19.3047 18.2423 19.1095L16.1996 17.0667C16.0043 16.8714 15.6877 16.8714 15.4925 17.0667C15.2972 17.262 15.2972 17.5786 15.4925 17.7738L17.5352 19.8166C17.7305 20.0118 18.0471 20.0118 18.2423 19.8166Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M38.4647 19.8163C38.2694 20.0116 37.9529 20.0116 37.7576 19.8163C37.5623 19.6211 37.5623 19.3045 37.7576 19.1092L39.8 17.0668C39.9953 16.8715 40.3119 16.8715 40.5071 17.0668C40.7024 17.262 40.7024 17.5786 40.5071 17.7739L38.4647 19.8163Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M37.7576 35.8443C37.9529 35.6491 38.2694 35.6491 38.4647 35.8443L40.5071 37.8868C40.7024 38.082 40.7024 38.3986 40.5071 38.5939C40.3119 38.7891 39.9953 38.7891 39.8 38.5939L37.7576 36.5514C37.5623 36.3562 37.5623 36.0396 37.7576 35.8443Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M18.2423 35.8443C18.4376 36.0396 18.4376 36.3562 18.2423 36.5514L16.1996 38.5942C16.0043 38.7894 15.6877 38.7894 15.4925 38.5942C15.2972 38.3989 15.2972 38.0823 15.4925 37.8871L17.5352 35.8443C17.7305 35.6491 18.0471 35.6491 18.2423 35.8443Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M17.1667 27.7535H15.0001V28.7535H17.1667V27.7535Z", fill: "#5E63E5" }),
        /* @__PURE__ */ C("path", { d: "M41 27.7535H38.8333V28.7535H41V27.7535Z", fill: "#5E63E5" })
      ]
    }
  );
}
d.__tags = [];
export {
  d as MetricBulbIcon
};
//# sourceMappingURL=index.es383.js.map
